// extracted by mini-css-extract-plugin
export default {"wrapper":"xVTtf5eXbmevaHSa4qwG","dragIcon":"ieoc5bGwN4qCeU0Xpu85","removeButton":"hbLfB1mr5_mdrrn_gAH9"};